import { Dialog, DialogContent, DialogActions } from "@mui/material";
import CustomPrimaryButton from "@fuse/core/CustomPrimaryButton/CustomPrimaryButton";
import { useNavigate } from "react-router";
import { useLayoutEffect, useState } from "react";
import petService from "@fuse/services/petService";
import paymentService from "@fuse/services/paymentService";
import { IPetModel } from "@fuse/models";
import { IApiResponse } from "@fuse/models/user.models";
import {
    Typography
} from "@mui/material";
import { useAppSelector } from "app/store";
import { selectPeevaSettings } from "app/store/fuse/peevaSettings";
import PlanType from "src/app/main/auth/types/plan.type";
import FuseLoading from "@fuse/core/FuseLoading";


function ActivatePetModal({ petId }) {
	const navigate = useNavigate();
	const appSettings = useAppSelector(selectPeevaSettings);
	const [pet, setPet] = useState<IPetModel>({} as IPetModel);
	const [customError, setCustomError] = useState("");
	const [loading, setLoading] = useState(false);
	const [plans, setPlans] = useState<PlanType[]>([]);
	
	useLayoutEffect(() => {
		petService
			.getPetById(petId)
			.then((res: any) => {
				if (res.result) {
					setPet(res.result);
				}
			})
			.catch((error) => {
				console.log(error);
			});

		petService
			.getPetPlans()
			.then((res: any) => {
				if (res.result) {
					setPlans(res.result.plans);

					const plans = res.result.plans as Array<PlanType>;
					plans.forEach((p) => {
						selectedPlansPush(p);
					});

					onPlansView(plans);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	async function onCardSelect() {
		setLoading(true);
		const lifetimePlan = plans.find((p) => p.oneTime === true);
		const selectedPlanId = lifetimePlan.id;
		const resp = (await petService.updatePetPlan(petId, {
			id: petId,
			planId: selectedPlanId,
		})) as IPetModel;

		if (resp.id) {
			const tagSelected = false;

			const checkout = (await paymentService.getCheckoutUrl(
				resp.id,
				true, tagSelected
			)) as IApiResponse;

			if (checkout.succeeded) {
				setLoading(false);
				location.href = checkout.result.location;
			} else {
				setCustomError(checkout.errors[0]);

				setTimeout(() => {
					setCustomError("");
					setLoading(false);
				}, 5000);
			}
		} else {
			setLoading(false);
		}
	}

	function selectedPlansPush(plan: PlanType) {
		const experimentName = plan.oneTime ? "lifetime" : "yearly";
		//@ts-ignore
		window.dataLayer = window.dataLayer || [];

		//@ts-ignore
		window.dataLayer.push({
			event: "experiment_play",
			experiment_name: experimentName,
			experiment_variant: plan.planPrice,
		});
	}

	
	function onPlansView(plans: PlanType[]) {
		const plan = plans[0];
		const sum = plans.reduce((t, el) => t + el.planPrice, 0);
		const items = [];
		plans.forEach((p) => {
			items.push({
				item_id: p.planId,
				item_name: p.name,
				item_variant: p.priceId,
				price: p.planPrice,
			});
		});

		//@ts-ignore
		window.dataLayer = window.dataLayer || [];

		//@ts-ignore
		window.dataLayer.push({
			event: "view_item",
			currency: plan.currency,
			value: sum,
			items: [...items],
		});
	}

	return (
		<>
		
		<Dialog
			open
			maxWidth="sm"
			fullWidth
			PaperProps={{
				sx: {
					borderRadius: 3,
					textAlign: "center",
					p: 2,
					position: "relative",
				},
			}}
		>
			{loading && (
				<div
					style={{
						position: "absolute",
						inset: 0,
						zIndex: 10,
						backgroundColor: "rgba(255,255,255,0.75)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<FuseLoading />
				</div>
			)}
			<DialogContent>
				<img
					src="assets/img/warning.png"
					alt="warning"
					style={{ width: 48, margin: "0 auto 16px" }}
				/>

				<Typography variant="h6" fontWeight={700} gutterBottom>
					Your pet's microchip is NOT linked to you
				</Typography>

				<Typography color="text.secondary">
					If your pet is found today, shelters and veterinarians won't see a verified owner record for this microchip.
                    Activate now to link your contact information and add emergency contacts, medical notes, and photos.
				</Typography>
			</DialogContent>

			<DialogActions sx={{ justifyContent: "center", pb: 2 }}>
				<CustomPrimaryButton
					onClick={() => onCardSelect()}
				>
					Activate and Protect my pet
				</CustomPrimaryButton>
			</DialogActions>
		</Dialog>
	</>
	);
}

export default ActivatePetModal;